export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ04.1350dc5b.mp3";